import { render } from "./SkiSchoolDetail.vue?vue&type=template&id=30e099ca&scoped=true"
import script from "./SkiSchoolDetail.vue?vue&type=script&lang=js"
export * from "./SkiSchoolDetail.vue?vue&type=script&lang=js"

import "./SkiSchoolDetail.vue?vue&type=style&index=0&id=30e099ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30e099ca"]])

export default __exports__